"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Slippers = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Slippers = function Slippers(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.329 8.22l.413 3.86a2.948 2.948 0 002.936 2.638 2.947 2.947 0 002.936-2.638l.408-3.81a5.575 5.575 0 00-6.693-.05z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.678 1.28A3.68 3.68 0 00.021 5.35l.195 1.818c2.242-1.376 4.872-1.248 6.92.043l.199-1.86a3.68 3.68 0 00-3.657-4.07zm1.235 4.052a5.752 5.752 0 00-2.475-.014L2.24 4.4a6.69 6.69 0 012.882.017l-.21.914zm4.06 2.888l.413 3.86a2.948 2.948 0 002.936 2.64 2.948 2.948 0 002.936-2.64l.408-3.809a5.573 5.573 0 00-6.693-.05z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.058 2.5a3.68 3.68 0 00-6.392 2.852l.194 1.817c2.038-1.25 4.675-1.373 6.92.043l.2-1.86a3.684 3.684 0 00-.922-2.851zm-1.5 2.832a5.753 5.753 0 00-2.476-.013l-.198-.917a6.689 6.689 0 012.882.017l-.209.913z",
    fill: "currentColor"
  }));
};

exports.Slippers = Slippers;
var _default = Slippers;
exports.default = _default;